import { createReducer } from '@reduxjs/toolkit';

import * as navigationActions from '../actions/navigation.action';

const initialState = {
  textOverflow: {
    visible: false,
    loading: false,
    locked: true
  }
};

const closeTextOverflow = (state) => {
  state.textOverflow.visible = false;
};

const openTextOverflow = (state) => {
  state.textOverflow.visible = true;
};

const toggleLoadingTextOverflow = (state) => {
  state.textOverflow.loading = !state.textOverflow.loading;
};

const toggleLockedTextOverflow = (state, { payload }) => {
  if (typeof payload === 'undefined') {
    state.textOverflow.locked = !state.textOverflow.locked;
  } else {
    state.textOverflow.locked = !!payload;
  }
};

export default createReducer(initialState, builder => {
  builder
    .addCase(navigationActions.openTextOverflow, openTextOverflow)
    .addCase(navigationActions.closeTextOverflow.fulfilled, closeTextOverflow)
    .addCase(navigationActions.toggleLoadingTextOverflow, toggleLoadingTextOverflow)
    .addCase(navigationActions.toggleLockedTextOverflow, toggleLockedTextOverflow);
});
